<template>
      <div class="load-bag" v-if="showLoader">
        <div class="lds-ripple" ><div></div><div></div></div>
      </div>
    <dashboard/>
   <div class="modal-dialog modal-lg down">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Admin Profile</h5>
              <!-- <a href="#l" data-toggle="modal"
                      data-target=".profile-modal" style="color:rgb(25, 25, 25)">
                      <i class="fa fa-edit" style="color:#16bc91e3"></i> Edit
              </a> -->
            </div>
            <div class="modal-body">
              <div class="custom-table">
                <table class="table-bordered w-100">
        <tbody>
            <tr>
            <th class="p-3"><i class="fa fa-user" style="color:#16bc91e3"></i> Name</th>
            <td class="p-3">{{ this.viewname }}</td>
            </tr>
            <tr>
            <th class="p-3"><i class="fa fa-envelope" style="color:#16bc91e3"></i>  Email</th>
            <td class="p-3" >{{ this.email }}</td>
            </tr>
        </tbody>
    </table>
                  </div>
            </div>
          </div>
        </div>
        <div
        class="modal fade profile-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg ">
          <div class="modal-content profile-edit">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Edit Profile</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="col-lg-8 col-md-12 col-sm-12">
                 <div class="form-group">
                   <label>Name</label>
                   <input type="text" v-model="viewname" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-3 col-md-12 col-sm-12">
                  <input type="button" @click="Editprofile" value="Save" class="modal-btn" />
                </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import Dashboard from '../../components/Dashboard.vue';
import axios from "../../services/customAxios";
import { base_url } from "../../config";
export default defineComponent({
  components: { Dashboard },
  setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
  data(){
    return{
      result:[],  
      viewname:"",
      email:"",
      showLoader:true,
    }
  },
  methods:{
    async LoadProfile() {
      let response = await axios.get(`${base_url}/get_admin`); 
      this.viewname = response.data.result[0].name;
      this.email = response.data.result[0].email;
      this.showLoader= false;
    },
  //   async Editprofile() {
  //   try{
  //      let response = await axios.post(`${base_url}/update-profile`, {
  //        name: this.viewname,
  //      });
  //     createToast({title: "Success", description: response.data.message},{type: "success"})
  //      if(response.data.status == 'success'){
  //        window.location.reload();
  //      }
  //     }
  //     catch(error){
  //       createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
  //     }
  //  },
  },
  mounted() {
    this.LoadProfile();
  }

})
</script>

<style>
.down{
    margin-top: 12%;
    margin-left: 30%;
}
.profile-edit{
  width: 70% !important;
  margin-left: 24%;
}
</style>
